import type { NodeId } from '@ipfabric/utils';
import type { GraphRendererPluginInterface } from 'components/Graph/GraphApp/plugins/GraphRendererPlugin';

/**
 * Determine whether a node is visualized in the graph
 *
 * The result includes hidden nodes when peeking is on,
 * and on the other hand it does not include nodes hidden
 * from technical reasons (e.g. culling).
 */
export const isNodeRenderable = (
  pluginInterface: GraphRendererPluginInterface,
  nodeId: NodeId,
): boolean =>
  pluginInterface.isPeekingAtHiddenNodes() ||
  !pluginInterface.getGraphData().hiddenNodes.has(nodeId);
